export default __webpack_public_path__ + "img/shape-star.2936bb4d.svg";